import type { SVGProps } from "react";

const SvgDolomitenSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="-15.6 24.4 543.2 463.1"
    fill="none"
    {...props}
  >
    <path
      fill="#F29313"
      d="M134.617 81c30.806.06 61.612-.03 92.419.05-31.196 116.6-62.372 233.2-93.567 349.8-30.827-.04-61.653 0-92.469-.02C72.266 314.24 103.351 197.6 134.617 81M211.233 157.539c5.67-24.638 11.071-49.346 16.861-73.943 11.02 40.929 21.901 81.899 32.892 122.839 3.454 13.996 4.063 28.561 3.095 42.906-1.627 22.422-6.03 44.524-10.761 66.466-8.376 37.486-17.1 74.892-25.386 112.387-8.924-32.564-17.48-65.238-26.264-97.852-3.374-12.967-7.407-25.845-9.044-39.192-2.336-17.92-.53-36.059 2.106-53.848 4.063-26.864 10.541-53.279 16.501-79.763M228.952 430.79c24.907-92.921 49.694-185.881 74.61-278.802 30.826.04 61.653 0 92.479.02-24.987 92.921-49.713 185.911-74.66 278.852-30.816-.09-61.623.05-92.429-.07M382.934 216.448c4.671-20.665 9.393-41.3 14.005-61.974C421.826 246.546 446.223 338.738 471 430.84c-30.826 0-61.652-.03-92.469.01-3.583-13.258-7.097-26.525-10.661-39.792-2.815-10.452-5.63-20.964-6.668-31.766-1.708-15.503-.26-31.146 1.826-46.54 4.622-32.494 12.808-64.309 19.906-96.304"
    />
  </svg>
);
export default SvgDolomitenSmallLogo;
